<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene3',
  mixins: [ SceneMixin ],

  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      this.$els[index]['container'].removeChild(sp)
    })

    this.$container.removeChild(this.$scene)

    this.$intro.kill()
    this.$outro.kill()

    this.$slide.kill()
    this.$motion.kill()

    this.$frise_in.kill()
    this.$frise_out.kill()

    // Castor

    this.$sub1.kill()
    this.$sub2.kill()
    this.$sub3.kill()

    // this.$Slide

    this.$slide1.kill()
    this.$slide2.kill()

    // this.$Slide Duck

    this.$sub4.kill()
    this.$sub5.kill()
    this.$sub6.kill()

    // Tournesol

    this.$sub7.kill()
    this.$sub71.kill()
    this.$sub8.kill()

  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene3 = this.$scene

    const bkg_container = new Container()
    this.$scene.addChild(bkg_container)
    this.setCenterContainer(bkg_container)

    const animals = new Container()
    this.$scene.addChild(animals)
    this.setCenterContainer(animals)

    const elements_container = new Container()
    this.$scene.addChild(elements_container)
    this.setCenterContainer(elements_container)
    elements_container.x += this.$canvas_width

    const castor_container = new Container()
    elements_container.addChild(castor_container)
    castor_container.y -= 50

    const castor_container_extra = new Container()
    elements_container.addChild(castor_container_extra)
    castor_container_extra.x += 125
    castor_container_extra.y -= 50

    const duck_container = new Container()
    elements_container.addChild(duck_container)
    duck_container.x += this.$canvas_width*1.8

    const duck_container_extra = new Container()
    elements_container.addChild(duck_container_extra)
    duck_container_extra.x += this.$canvas_width*1.8 + 250
    duck_container_extra.y += this.$canvas_height*.5
    
    const tournesol_container = new Container()
    elements_container.addChild(tournesol_container)
    tournesol_container.x += this.$canvas_width*3.4
    tournesol_container.y -= 50

    // Timelines

    this.$intro = new TimelineMax()
    this.$outro = new TimelineMax()

    this.$slide = new TimelineMax()
    this.$motion = new TimelineMax()

    this.$frise_in = new TimelineMax()
    this.$frise_out = new TimelineMax()

    // Castor

    this.$sub1 = new TimelineMax()
    this.$sub2 = new TimelineMax()
    this.$sub3 = new TimelineMax()

    // this.$Slide

    this.$slide1 = new TimelineMax()
    this.$slide2 = new TimelineMax()

    // this.$Slide Duck

    this.$sub4 = new TimelineMax()
    this.$sub5 = new TimelineMax()
    this.$sub6 = new TimelineMax()

    // Tournesol

    this.$sub7 = new TimelineMax()
    this.$sub71 = new TimelineMax()
    this.$sub8 = new TimelineMax()
    this.$sub9 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {

      'bg_s3' : { container: bkg_container, alpha: 0 },
      
      'goat' : { container: animals, alpha: .75, y: 620, x: 800, scale: this.$root.$scale*0.8 },
      'fish' : { container: animals, alpha: 1, y: 420, x: 1900 },
      'fish_2' : { container: animals, alpha: 1, y: 420, x: 1600 },
      
      'feuilles1' : { container: animals, alpha: 1, y: -100, x: 800 },
      'feuilles2' : { container: animals, alpha: 0, y: 100, x: 650 },

      'castor_back_left': { container: castor_container, alpha: 1, position: { x: 278, y: 411, width: 610, height: 859 }, anchor: { x:1, y:1 }},
      'castor_back_right': { container: castor_container, alpha: 1, position: { x: 709, y: 411, width: 610, height: 859 }, anchor: { x:0, y:1 }},
      
      'castor_deco_1': { container: castor_container, alpha: .75, position: { x: 829, y: 1342, width: 506, height: 332 }, anchor: { x:0, y:0 }},
      'castor_deco_2': { container: castor_container, alpha: .25, position: { x: 0, y: 0, width: 1536, height: 2160 }, pivot: { x: -589, y: 85 }},
      'castor_deco_3': { container: castor_container, alpha: .8, position: { x: 727, y: 1402, width: 299, height: 290 }, anchor: { x:0, y:0 }},
      'castor_deco_4': { container: castor_container, alpha: .8, position: { x: 221, y: 1292, width: 199, height: 193 }, anchor: { x:0.5, y:1 } }, 
      'castor_front_1': { container: castor_container, alpha: 1, position: { x: 437, y: 1257, width: 262, height: 484 }, anchor: { x:1, y:0 }},
      'castor_animal': { container: castor_container, alpha: 1, position: { x: 351, y: 822, width: 857, height: 835 }},

      'duck_deco_1': { container: duck_container, alpha: 1, position: { x: 994, y: 836, width: 243, height: 332 }, anchor: { x:0, y:1 }},
      'duck_deco_2': { container: duck_container, alpha: 1, position: { x: 363, y: 1234, width: 798, height: 501 }, anchor: { x:0, y:0 }},
      'duck_wing': { container: duck_container, alpha: 1, position: { x: 307, y: 572, width: 664, height: 423 }, anchor: { x:1, y:1 }},
      'duck_animal': { container: duck_container, alpha: 1, position: { x: 113, y: 504, width: 910, height: 767 }},
      'duck_front_4': { container: duck_container, alpha: .75, position: { x: 259, y: 1015, width: 299, height: 257 }, anchor: { x:0, y:1 }},
      'duck_front_3': { container: duck_container, alpha: 1, position: { x: 376, y: 1272, width: 409, height: 390 }},
      'duck_front_2': { container: duck_container, alpha: .8, position: { x: 402, y: 1118, width: 543, height: 169 }},
      'duck_front_1': { container: duck_container, alpha: 1, position: { x: 242, y: 1107, width: 1032, height: 436 }},

      'tournesol_deco_11': { container: tournesol_container, alpha: 1, position: { x: 259, y: 1001, width: 440, height: 549 }, anchor: { x:1, y:1 } },
      'tournesol_deco_12': { container: tournesol_container, alpha: 1, position: { x: 699, y: 1001, width: 605, height: 549 }, anchor: { x:0, y:1 }},
      'tournesol_deco_2': { container: tournesol_container, alpha: 1, position: { x: 229, y: 848, width: 639, height: 625 }},
      'tournesol_deco_3': { container: tournesol_container, alpha: 1, position: { x: 587, y: 960, width: 448, height: 642 }},
      'tournesol_deco_4': { container: tournesol_container, alpha: 1, position: { x: 284, y: 867, width: 462, height: 652 }, anchor: { x:1, y:1 }},
      'tournesol_petals_1': { container: tournesol_container, alpha: 1, position: { x: 531, y: 597, width: 482, height: 474 }},
      'tournesol_petals_2': { container: tournesol_container, alpha: 1, position: { x: 531, y: 597, width: 482, height: 474 }},
      'tournesol_tige': { container: tournesol_container, alpha: 1, position: { x: 652, y: 867, width: 202, height: 570 }},
      'tournesol_small': { container: tournesol_container, alpha: 1, position: { x: 656, y: 714, width: 228, height: 227 }},
      'tournesol_centre': { container: tournesol_container, alpha: 1, position: {  x: 656, y: 714, width: 228, height: 227 }},
      'tournesol_feuille_1': { container: tournesol_container, alpha: 1, position: { x: 438, y: 976, width: 271, height: 278 }, anchor: { x:1, y:.5 }},
      'tournesol_feuille_2': { container: tournesol_container, alpha: 1, position: { x: 798, y: 1080, width: 387, height: 289 }, anchor: { x:0, y:0.5 }},
      'tournesol_feuille_3': { container: tournesol_container, alpha: 1, position: { x: 748, y: 1314, width: 225, height: 221 }, anchor: { x:0, y:1 }},
      'tournesol_feuille_4': { container: tournesol_container, alpha: 1, position: { x: 456, y: 1218, width: 328, height: 353 }, anchor: { x:1, y:1 }},

      'extra_11': { container: castor_container_extra, alpha: .75, position: { x: 345, y: 250, width: 2012, height: 1276 }, pivot: { x: 7, y: -381 }},
      'extra_111': { container: castor_container_extra, alpha: .75, position: { x: 345, y: 250, width: 2012, height: 1276 }, pivot: { x: 699, y: -38 }},
      'extra_12': { container: castor_container_extra, alpha: .75, position: { x: 345, y: 250, width: 2012, height: 1276 }, pivot: { x: 180, y: 45 }},
      'extra_13': { container: castor_container_extra, alpha: .75, position: { x: 345, y: 250, width: 2012, height: 1276 }, pivot: { x: 200, y: -303 }},
      'extra_14': { container: castor_container_extra, alpha: .75, position: { x: 345, y: 250, width: 2012, height: 1276 }, pivot: { x: 542, y: -230 }},
      'extra_15': { container: castor_container_extra, alpha: .75, position: { x: 345, y: 250, width: 2012, height: 1276 }, pivot: { x: 99, y: 68 }},
      'extra_16': { container: castor_container_extra, alpha: .75, position: { x: 345, y: 250, width: 2012, height: 1276 }, pivot: { x: 316, y: 348 }},

      'extra_21': { container: castor_container_extra, alpha: .75, position: { x: 1600, y: 750, width: 1434, height: 492 }, pivot: { x: 0, y: -137 }, rotation: 10 },
      'extra_22': { container: castor_container_extra, alpha: .75, position: { x: 1600, y: 750, width: 1434, height: 492 }, pivot: { x: 402, y: -246 }, rotation: 10 },

      'extra_31': { container: elements_container, alpha: 1, position: { x: 3920, y: 725, width: 1022, height: 622 }, pivot: { x: -211, y: 37 }},
      'extra_32': { container: elements_container, alpha: 1, position: { x: 3920, y: 725, width: 1022, height: 622 }, pivot: { x: -140, y: -319 }},
      'extra_33': { container: elements_container, alpha: 1, position: { x: 3920, y: 775, width: 1022, height: 622 }, pivot: { x: 70, y: 4 }},
      'extra_34': { container: elements_container, alpha: 1, position: { x: 3920, y: 725, width: 1022, height: 622 }, pivot: { x: 240, y: -335 }},

      'extra_41': { container: elements_container, alpha: 1, position: { x: 5000, y: 725, width: 2580, height: 901 }, pivot: { x: 300, y: -334 }},
      'extra_42': { container: elements_container, alpha: 1, position: { x: 5000, y: 725, width: 2580, height: 901 }, pivot: { x: 450, y: 35 }},
      'extra_43': { container: elements_container, alpha: 1, position: { x: 5000, y: 725, width: 2580, height: 901 }, pivot: { x: 570, y: -375 }},
      'extra_44': { container: elements_container, alpha: 1, position: { x: 5000, y: 725, width: 2580, height: 901 }, pivot: { x: 675, y: -143 }},
      'extra_45': { container: elements_container, alpha: 1, position: { x: 5000, y: 725, width: 2580, height: 901 }, pivot: { x: 925, y: -451 }},
      'extra_46': { container: elements_container, alpha: 1, position: { x: 5000, y: 725, width: 2580, height: 901 }, pivot: { x: 1052, y: -443 }},
      'extra_47': { container: elements_container, alpha: 1, position: { x: 5000, y: 725, width: 2580, height: 901 }, pivot: { x: 1256, y: -389 }},
  
    }

    _.each(els, (el, name)=>{
      let sp = null
      const sprite = new Sprite.from(this.$resources[name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
      if(!el.pivot) { sp = sprite }
      else {
        const cn = new Sprite()
        sprite.x = el.pivot.x/2
        sprite.y = el.pivot.y/2 
        cn.addChild(sprite)
        sp = cn
      }
      sp.alpha = el.alpha
      el.container.addChild(sp)
      sprites[name] = sp
      this.applySettings(sp, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    const InContainer = (container)=>{
      const tml = new TimelineMax()
            .add([ 
              TweenMax.from(container, .25, { pixi: { alpha: 0 }, ease: Cubic.easeOut}),
              TweenMax.from(container, 1, { pixi: { scale: this.$root.$scale*0.65 }, ease: Cubic.easeOut}),
            ])
      return tml
    }

    const OutContainer = (container)=>{
      const tml = new TimelineMax()
            .add([ 
              TweenMax.to(container, 1, { pixi: { alpha: 0 }, ease: Cubic.easeOut, delay: .5 }),
              TweenMax.to(container, 1, { pixi: { scale: this.$root.$scale*0.5 }, ease: Cubic.easeIn }),
            ])
      return tml
    }

    // ******************************************************** //
    // ******************************************************** //

    const d1 = 1.25
    this.$intro
      .to(sprites['bg_s3'], d1*.25, { pixi:{ alpha: .9 }, ease: Linear.easeNone })

    this.$frise_in
      .to(this.$parent.$scene2, d1*.75 , { pixi: { scale: '+='+ 0.20 }, ease: Linear.easeNone  })

    // Castor this.$motion

    const d2 = 1.25
    // const castorFilter = new PIXI.filters.AlphaFilter(1.0)
    // castor_container.filters = [ castorFilter ]

    this.$sub1
      .set({}, { delay: .5 })
      .add([ InContainer(castor_container) ])
      .add([ OutContainer(castor_container) ])
      .set({}, { delay: .25 })
      .add([ InContainer(duck_container) ])
      .add([ OutContainer(duck_container) ])
      .add([ InContainer(tournesol_container) ])
      .add([ OutContainer(tournesol_container) ])

    this.$sub2
      .set({}, { delay: 1.25 })
      .add([
        TweenMax.from(castor_container_extra, 1, { pixi: { scale: this.$root.$scale*0.65 }, ease: Cubic.easeOut}),
      ])
      .add([
        TweenMax.to(castor_container_extra, 1, { pixi: { alpha: 0 }, ease: Cubic.easeOut, delay: .5 }),
        TweenMax.to(castor_container_extra, 1, { pixi: { scale: this.$root.$scale*0.75 }, ease: Cubic.easeIn }),
      ])

      .set({}, { delay: .5 })

      .add([
        TweenMax.from(sprites['extra_31'], 1, { pixi: { scale: this.$root.$scale*0.65 }, ease: Cubic.easeOut}),
        TweenMax.from(sprites['extra_32'], 1.05, { pixi: { scale: this.$root.$scale*0.65, rotation: 30 }, ease: Cubic.easeOut}),
        TweenMax.from(sprites['extra_33'], 1.05, { pixi: { scale: this.$root.$scale*0.65, rotation: 20 }, ease: Cubic.easeOut}),
        TweenMax.from(sprites['extra_34'], 2 , { pixi: { scale: this.$root.$scale*0.65, rotation: 30 }, ease: Cubic.easeOut}),
      ])
      .add([
        TweenMax.to(sprites['extra_31'], 1, { pixi: { scale: this.$root.$scale*0.25 }, ease: Cubic.easeOut}),
        TweenMax.to(sprites['extra_32'], 1.05, { pixi: { scale: this.$root.$scale*0.25 }, ease: Cubic.easeOut}),
        TweenMax.to(sprites['extra_33'], 1.05, { pixi: { scale: this.$root.$scale*0.25, }, ease: Cubic.easeOut}),
        TweenMax.to(sprites['extra_34'], .5 , { pixi: { scale: this.$root.$scale*0.25 }, ease: Cubic.easeOut}),
      ])

    const d3 = 2.5
    this.$slide
      .to(elements_container, d3*3+d2, {  pixi: { x: '-='+ this.$canvas_width*6 }, ease: Linear.easeNone })

    this.$sub4
      .set({}, { delay: .5 })
      .add([
        TweenMax.from(sprites['castor_back_left'], .5, { pixi:{ rotation: 30, alpha:0.2 }, ease: Back.easeOut }),
        TweenMax.from(sprites['castor_back_right'], .5, { pixi:{ rotation: -30, alpha:0.2 }, ease: Back.easeOut }),
        TweenMax.to(sprites['castor_front_1'], .5, { pixi:{ rotation: 30, alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['castor_deco_1'], 1.5, { pixi:{ rotation: -40, alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['castor_deco_3'], 3, { pixi:{ rotation: 20, alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['castor_back_left'], .75, { pixi:{ rotation: 15 }, ease: Linear.easeNone, delay: .80 }),
        TweenMax.to(sprites['castor_back_right'], .75, { pixi:{ rotation: -15 }, ease: Linear.easeNone, delay: .80 }),
        TweenMax.from(sprites['extra_11'], this.$slide.duration()*0.15, { pixi:{ alpha:0, rotation: -20 }, ease: Linear.easeNone, delay: this.$slide.duration()*0.01 }),
        TweenMax.from(sprites['extra_111'], this.$slide.duration()*0.25, { pixi:{ alpha:0, x: '+=100' }, ease: Linear.easeNone, delay: this.$slide.duration()*0.015 }),
        TweenMax.from(sprites['extra_12'], this.$slide.duration()*0.12, { pixi:{ alpha:0, rotation: 50, scale: this.$root.$scale*0.7 }, ease: Linear.easeNone, delay: this.$slide.duration()*0.03 }),
        TweenMax.from(sprites['extra_13'], this.$slide.duration()*0.20, { pixi:{ alpha:0, rotation: -20 }, ease: Linear.easeNone, delay: this.$slide.duration()*0.01 }),
        TweenMax.from(sprites['extra_14'], this.$slide.duration()*0.20, { pixi:{ alpha:0, x: '-=20' }, ease: Linear.easeNone, delay: this.$slide.duration()*0.075 }),
        TweenMax.from(sprites['extra_15'], this.$slide.duration()*0.20, { pixi:{ alpha:0, rotation: 20, scale: this.$root.$scale*0.7 }, ease: Linear.easeNone, delay: this.$slide.duration()*0.05 }),
        TweenMax.from(sprites['extra_16'], this.$slide.duration()*0.15, { pixi:{ alpha:0, rotation: 20, scale: this.$root.$scale*0.7 }, ease: Linear.easeNone, delay: this.$slide.duration()*0.05 }),
        TweenMax.from(sprites['extra_21'], this.$slide.duration()*0.30, { pixi:{ x: '+=100', alpha: 0 }, ease: Linear.easeNone, delay: this.$slide.duration()*0.04 }),
        TweenMax.from(sprites['extra_22'], this.$slide.duration()*0.20, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: this.$slide.duration()*0.02 }),
      ])

    // Duck

    // const duckFilter = new PIXI.filters.AlphaFilter(1)
    // duck_container.filters = [ duckFilter ]

    this.$sub6
      .set({}, { delay: 3.5 })
      .add([
        TweenMax.from(sprites['duck_front_3'], .5, { pixi:{ x:'-='+ els['duck_front_1'].x, alpha:0, ease: Back.easeOut }}),
        TweenMax.from(sprites['duck_wing'], 1, { pixi:{ rotation: 15, alpha:.25 }, ease: Linear.easeNone }),
        TweenMax.from(sprites['duck_deco_2'], 2, { pixi:{ rotation: 30, alpha: .35 }, ease: Linear.easeNone }),
        TweenMax.from(sprites['duck_deco_1'], .75, { pixi:{ rotation: 40, alpha: .5, ease: Linear.easeNone }}, '-=1'),
      ])

    // Tournesol

    // const tournesolFilter = new PIXI.filters.AlphaFilter(1)
    // tournesol_container.filters = [ tournesolFilter ]

    const extras = [ sprites['extra_41'],sprites['extra_42'],sprites['extra_43'],sprites['extra_44'],sprites['extra_45'],sprites['extra_46'],sprites['extra_47']]

    this.$sub9
      .set({}, { delay: 4.2 })
      .from(sprites['tournesol_feuille_4'], 1, { pixi:{ rotation: 30, alpha: 0 }, ease: Linear.easeNone })
      .from(sprites['tournesol_feuille_1'], 1, { pixi:{ rotation: 20, alpha: 0 }, ease: Linear.easeNone })
      .add([
        TweenMax.from(sprites['tournesol_deco_11'], 1, { pixi:{ alpha: .75, rotation: 40 }, ease: Linear.easeNone }),
        TweenMax.from(sprites['tournesol_deco_12'], 1, { pixi:{ alpha: .7, rotation: 20 }, ease: Cubic.easeOut }),
        TweenMax.from(sprites['tournesol_deco_2'], 1, { pixi:{ alpha: .25 }, ease: Linear.easeNone, delay: .5 }),
        TweenMax.from(sprites['tournesol_deco_4'], 1, { pixi:{ alpha: .25 }, ease: Linear.easeNone, delay: .5 }),
        TweenMax.from(sprites['extra_41'], 1 , { pixi:{ alpha: 0, rotation: 40,  }, ease: Cubic.easeOut, delay: .2 }),
        TweenMax.from(sprites['extra_42'], 1 , { pixi:{ alpha: 0, rotation: 60,  }, ease: Cubic.easeOut, delay: .22}),
        TweenMax.from(sprites['extra_43'], 1, { pixi:{ alpha: 0, rotation: 40, x: '-=20' }, ease: Cubic.easeOut, delay: .25 }),
        TweenMax.from(sprites['extra_44'], 1, { pixi:{ alpha: 0, rotation: 60, x: '-=50' }, ease: Cubic.easeOut, delay: .25 }),
        TweenMax.from(sprites['extra_45'], 1 , { pixi:{ alpha: 0, rotation: 60, x: '-=55' }, ease: Cubic.easeOut, delay: .25 }),
        TweenMax.from(sprites['extra_46'], 1, { pixi:{ alpha: 0, rotation: 60, x: '-=60' }, ease: Cubic.easeOut, delay: .25 }),
        TweenMax.from(sprites['extra_47'], 1, { pixi:{ alpha: 0, rotation: 60, x: '-=70' }, ease: Cubic.easeOut, delay: .25 }),
      ])
      .add([
        TweenMax.staggerTo(extras, .25, { pixi: { alpha: 0 }, ease: Cubic.easeOut }, 0.1),
      ])
      
    this.$outro
      .set({}, { delay: this.$slide.duration()*.95 })
      .add([
        TweenMax.to(sprites['bg_s3'], this.$slide.duration()*.05, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
      ])

    this.$frise_out
      .set({}, { delay: this.$slide.duration()*.8 })
      .to(this.$parent.$scene2, this.$slide.duration()*.2, { pixi: { scale: '-='+ 0.20 }, ease: Cubic.easeOut })

    const tl1 = new TimelineMax()

    tl1.add([ this.$intro, this.$frise_in ])
    tl1.add([ this.$slide, this.$sub1, this.$sub2, this.$sub4, this.$sub5, this.$sub6, this.$sub7, this.$sub71, this.$sub8, this.$sub9, this.$outro, this.$frise_out ])

    const appear = this.$slide.duration()
    const inside = new TimelineMax()
          .add([
            TweenMax.from(sprites['fish'], appear*0.05, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.25 }),
            TweenMax.from(sprites['fish_2'], appear, { pixi:{ x: '+=500' }, ease: Linear.easeNone }), 
            TweenMax.from(sprites['feuilles1'], appear*0.1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: appear*0.25 }),
            TweenMax.from(sprites['feuilles1'], appear, { pixi:{ x: '+=800' }, ease: Linear.easeNone }),
            TweenMax.from(sprites['goat'], 2, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 1 }),
            TweenMax.to(animals, appear*.9, { pixi:{ x: -2200 }, ease: Linear.easeNone }),
          ])

    this.$tl.add([ tl1, inside ], 31)

  },
  mounted() {
    // this.$parent.chapter.$tl.seek(36)
  }
}
</script>

















